module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp23_3.4c985c56.png";